import React from "react";
import UserDefinedFieldValueModel from "../../models/UserDefinedFieldValueModel";
import Field from "./Field";
import { FieldProps } from "./Types";
import UserDefinedFieldControl from "./UserDefinedFieldControl";

export interface UserDefinedFieldProps extends FieldProps {
    userDefinedFieldValue: UserDefinedFieldValueModel
}

const UserDefinedField: React.FC<UserDefinedFieldProps> = ({ labelProps, controlProps, visible, disabled, userDefinedFieldValue }) => {

    if (visible === false)
        return <></>;

    //console.log('options for:' + userDefinedFieldValue.userDefinedField.name, userDefinedFieldValue.userDefinedField.options)

    return (
        <Field {...labelProps}>
            <UserDefinedFieldControl controlProps={controlProps} dataTypeId={userDefinedFieldValue.userDefinedField.dataTypeId} options={userDefinedFieldValue.options} disabled={disabled} />
        </Field>
    );
}
export default UserDefinedField;